import { ThemeState } from '@shazambanking/sdk/styles';
import axios from 'axios';
import { NEW_ACCOUNT_STARTUP_URL, OPEN_NEW_ACCOUNT_URL, THEME_URL } from '../../Constants';
import { NewAccountFormValues, NewAccountStartupResource } from '../types';

export async function saveNewAccount(
  values: NewAccountFormValues,
): Promise<NewAccountFormValues> {
  let data: NewAccountFormValues;

  data = await submitNewAccount(values);
  return { ...data };
}

export async function submitNewAccount(values: NewAccountFormValues) {
  const { data } = await axios.post<NewAccountFormValues>(
    OPEN_NEW_ACCOUNT_URL,
    {
      accountProduct: values.accountProduct,
      firstName: values.firstName,
      middleName: values.middleName,
      lastName: values.lastName,
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      zip: values.zip,
      ssnLastFour: values.ssnLastFour,
      dateOfBirth: values.dateOfBirth,
      email: values.email,
      primaryPhone: values.primaryPhone,

      depositSource: values.depositSource,
      amount: values.amount,
    }
  );
  return data;
}

export async function getTheme(): Promise<any> {
  const { data } = await axios.get<ThemeState>(THEME_URL);
  return data;
}

export async function fetchNewAccountStartupData(): Promise<NewAccountStartupResource> {
  const data = await getNewAccountStartupData();
  return data;
}

export async function getNewAccountStartupData() {
  const { data } = await axios.get<NewAccountStartupResource>(
    NEW_ACCOUNT_STARTUP_URL,
    {
      params: {
        locale: 'en'
      }
    }
  );
  return data;
}
